import { useState, useEffect, ReactNode } from 'react';
import { ChevronRight, ChevronDown } from 'lucide-react';

interface CollapsibleCardProps {
  title: string;
  defaultOpen?: boolean;
  /** When this flips from false to true (e.g. entering edit mode), the card auto-opens. */
  forceOpenWhen?: boolean;
  className?: string;
  headerRight?: ReactNode;
  children: ReactNode;
}

const CollapsibleCard = ({
  title,
  defaultOpen = true,
  forceOpenWhen,
  className = '',
  headerRight,
  children,
}: CollapsibleCardProps) => {
  const [open, setOpen] = useState(defaultOpen);

  useEffect(() => {
    if (forceOpenWhen) setOpen(true);
  }, [forceOpenWhen]);

  return (
    <div className={`md-card ${className}`}>
      <div className="flex justify-between items-center px-6 py-4">
        <button
          type="button"
          onClick={() => setOpen(prev => !prev)}
          className="flex items-center gap-2 text-left flex-1 cursor-pointer focus:outline-none"
          aria-expanded={open}
        >
          {open ? (
            <ChevronDown className="w-5 h-5 text-[#6B7280]" />
          ) : (
            <ChevronRight className="w-5 h-5 text-[#6B7280]" />
          )}
          <h2 className="text-xl font-bold font-heading text-[#1A1F2B]">{title}</h2>
        </button>
        {open && headerRight && (
          <div className="flex items-center gap-3 ml-3">{headerRight}</div>
        )}
      </div>
      {open && <div className="px-6 pb-6 pt-2">{children}</div>}
    </div>
  );
};

export default CollapsibleCard;
